import { render, staticRenderFns } from "./ProtocoloEmMassaDlg.vue?vue&type=template&id=18a80723"
import script from "./ProtocoloEmMassaDlg.vue?vue&type=script&lang=js"
export * from "./ProtocoloEmMassaDlg.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloEmMassaDlg.vue?vue&type=style&index=0&id=18a80723&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports